import { Route, Routes } from "react-router-dom";
import TermsOfService from "./TermsOfService";
import PrivacyPolicy from "./PrivacyPolicy";
import CookiePolicy from "./CookiePolicy";
import RecruitmentPolicy from "./RecruitmentPolicy";
import Legal from "./Legal";
import SPPrivacyPolicy from "./SPPrivacyPolicy";
import { Slavery } from "./Slavery";

const Router = () => {
    return (
        <Routes>
            <Route path="/" element={<Legal />}>
                <Route path="terms" element={<TermsOfService />} />
                <Route path="privacy-policy" element={<PrivacyPolicy />} />
                <Route path="cookie-policy" element={<CookiePolicy />} />
                <Route path="recruitment-policy" element={<RecruitmentPolicy />} />
                <Route path="appprivacy" element={<SPPrivacyPolicy />} />
                <Route path="modern-slavery" element={<Slavery />} />
            </Route>
        </Routes>
    );
};

export default Router;